import { render } from "./CheckPointFlip.vue?vue&type=template&id=86c89a40"
import script from "./CheckPointFlip.vue?vue&type=script&lang=js"
export * from "./CheckPointFlip.vue?vue&type=script&lang=js"

import "./CheckPointFlip.vue?vue&type=style&index=0&id=86c89a40&lang=css"

import exportComponent from "D:\\All\\Job freelance\\CRA-brainy\\Develop\\cra-brainy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__